import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchMessengerMediaFilesApi,
  uploadFileMessengerApi,
} from "../../api/uploadFileMessengerApi";
import * as Endpoints from "../../entities/Endpoints";

// Thunk to fetch media files list
export const fetchMediaFilesListThunk = createAsyncThunk(
  Endpoints.GET_MESSENGER_CONVERSION_DETAILS,
  async ({ conversationId }, { rejectWithValue }) => {
    try {
      const response = await fetchMessengerMediaFilesApi(conversationId);
      return response;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.data?.title ||
        "An error occurred while fetching media files.";
      return rejectWithValue(errorMessage);
    }
  }
);

// Thunk to upload a file
export const uploadFileMessengerThunk = createAsyncThunk(
  Endpoints.ADD_MESSENGER_CONVERSION_DETAILS,
  async (requestPayload, { rejectWithValue }) => {
    try {
      const data = await uploadFileMessengerApi(requestPayload);
      return data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.message ||
        error?.data?.title ||
        "An error occurred while uploading file.";
      return rejectWithValue(errorMessage);
    }
  }
);

// Slice
const uploadFileMessengerSlice = createSlice({
  name: "uploadFileMessenger",
  initialState: {
    loading: false,
    mediaId: null,
    error: null,
    mediaFilesList: [],
    mediaFilesLoading: false,
    mediaFilesError: null,
  },
  reducers: {
    resetUploadFileMessengerState: (state) => {
      state.loading = false;
      state.mediaId = null;
      state.error = null;
      state.mediaFilesList = [];
      state.mediaFilesLoading = false;
      state.mediaFilesError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Upload file flow
      .addCase(uploadFileMessengerThunk.pending, (state) => {
        state.loading = true;
        state.mediaId = null;
        state.error = null;
      })
      .addCase(uploadFileMessengerThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.mediaId = action.payload?.mediaId || null;
        state.error = null;
      })
      .addCase(uploadFileMessengerThunk.rejected, (state, action) => {
        state.loading = false;
        state.mediaId = null;
        state.error = action.payload || "Failed to upload file.";
      })

      // Fetch media files flow
      .addCase(fetchMediaFilesListThunk.pending, (state) => {
        state.mediaFilesLoading = true;
        state.mediaFilesList = [];
        state.mediaFilesError = null;
      })
      .addCase(fetchMediaFilesListThunk.fulfilled, (state, action) => {
        state.mediaFilesLoading = false;
        state.mediaFilesList = action.payload || [];
        state.mediaFilesError = null;
      })
      .addCase(fetchMediaFilesListThunk.rejected, (state, action) => {
        state.mediaFilesLoading = false;
        state.mediaFilesList = [];
        state.mediaFilesError =
          action.payload || "Failed to fetch media files.";
      });
  },
});

export const { resetUploadFileMessengerState } =
  uploadFileMessengerSlice.actions;

export default uploadFileMessengerSlice.reducer;
